export const phantomSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 146 146"
    width="100%"
    height="100%"
    role="img"
    aria-label="Phantom Logo"
  >
    <title>Phantom Logo</title>
    <g clipPath="url(#clip0_phantom)">
      <rect width="146" height="146" rx="31.3" fill="#AB9FF2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.92 94.85C57.19 103.66 47.58 114.75 34.79 114.75C28.76 114.75 22.95 112.28 22.95 101.45C22.95 73.97 60.51 31.37 95.38 31.37C115.19 31.37 123.11 45.13 123.11 60.77C123.11 80.81 110.11 103.74 97.15 103.74C93.05 103.74 91.06 101.45 91.06 97.91C91.06 96.98 91.21 95.98 91.52 94.85C87.11 102.41 78.57 109.41 70.6 109.41C64.75 109.41 61.83 105.85 61.83 100.63C61.83 98.77 62.22 96.82 62.92 94.85ZM110.03 60.23C110.03 64.75 107.36 67.03 104.37 67.03C101.31 67.03 98.65 64.75 98.65 60.23C98.65 55.66 101.31 53.38 104.37 53.38C107.36 53.38 110.03 55.66 110.03 60.23ZM92.96 60.23C92.96 64.75 90.29 67.03 87.3 67.03C84.24 67.03 81.58 64.75 81.58 60.23C81.58 55.66 84.24 53.38 87.3 53.38C90.29 53.38 92.96 55.66 92.96 60.23Z"
        fill="#FFFDF8"
      />
    </g>
    <defs>
      <clipPath id="clip0_phantom">
        <rect width="146" height="146" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
